import './Paginate.scss';
import Component from './Paginate.js';
import ReactiveWrapper from '../ReactiveWrapper';
export default ReactiveWrapper(Component);